export default __webpack_public_path__ + "static/media/Agrarwetter.1abc372c.jpg";